export const SITUACAO = {
    RECUSADO: -2,
    EXPIRADO: -1,
    UPLOAD_PENDENTE: 0,
    EXPIRANDO: 1,
    AGUARDANDO_APROVACAO: 2,
    SEM_PENDENCIAS: 3,
}